import { Box } from '@mui/material'
import { ComponentPropsWithRef, forwardRef } from 'react'

type ScrollViewProps = ComponentPropsWithRef<'div'>
export const ScrollView = forwardRef<HTMLDivElement, ScrollViewProps>(
  (props, ref) => {
    return (
      <Box
        {...props}
        ref={ref}
        component="div"
        style={{
          width: '100%',
          height: '100dvh',
          position: 'relative',
          overflow: 'scroll',
          scrollSnapType: 'y mandatory',
        }}
      >
        {props.children}
      </Box>
    )
  }
)
